import { Box, styled } from '@mui/material';

const StyledSnackbarProviderContainer = styled(Box)(
  () => ({
    '.notistack-SnackbarContainer': {
      zIndex: 1301,
    },
  }),
);

export default StyledSnackbarProviderContainer;
